import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-soildata-action',
  templateUrl: './soildata-action.component.html',
  styleUrls: ['./soildata-action.component.scss']
})
export class SoildataActionComponent {
  constructor(
    public dialogRef: MatDialogRef<SoildataActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  handleAction(action: string): void {
    if (this.data && this.data.handleDialogAction) {
      this.data.handleDialogAction(action);
    }
    this.dialogRef.close();
  }

  canGetEconomicValues(): boolean {
    return (this.data.crop !== '')
  }
}
